// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"SitecoreForm_formWrapper__13890","form":"SitecoreForm_form__VlTxx","recaptchaContainer":"SitecoreForm_recaptchaContainer__2wqj2"};